import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { ProductRegistration } from '@app/components/apps/ProductRegistration/ProductRegistration';

export const ViewPRIFSPage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('View Product Registration');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const categoryId = Number(localStorage.getItem('selected_category_id')) || 0;
  const categoryName = localStorage.getItem('selected_category_name') || '';

  const routes = [
    { path: 'pr-categories', breadcrumbName: 'Product Registrations' },
    { path: 'product-registrations', breadcrumbName: categoryName },
    { path: '/view-product-registrations', breadcrumbName: currentBreadcrumName },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName, categoryId]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ProductRegistration
          type={'view'}
          editable={false}
          id={id}
          pageTitle={`View Product Registration`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default ViewPRIFSPage;
